<div
  class="cb-battle-player__skins--list"
  [class.lose]="showResults() && !isWinner() && animation() === 'finished'"
>
  @for (skin of drops() | keyvalue; track $index;) {
  <div
    class="cb-battle-player__skins--item"
    [class.lose]="showResults() && !isWinner() && animation() === 'finished'"
  >
    <app-skin
      @fadeInAnimation
      [skin]="skin.value"
      [balanceType]="player()?.balance ?? null"
    ></app-skin>
  </div>
  }
  <div
    class="cb-battle-player__skins--slot {{ battle().mode }}"
    [class.red]="showResults() && !isWinner()"
    [class.green]="showResults() && isWinner()"
  >
    slot: {{ slot() }}
  </div>
</div>
